/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { nthChildIterator, pxToEm, pxToEmWithBaseline } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : RATING CODE : STYLES --------------- ++++++++++ */
export default theme => ({
  advanced: {
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      marginTop: '16px'
    },
    '& .migration': {
      fontSize: pxToEm(16),
      lineHeight: pxToEmWithBaseline({ value: 20, fontSizeBaseline: 16 }),
      display: 'flex',
      flexDirection: 'column',
      '& > *': {
        marginTop: '16px'
      }
    },
    '& .code': {
      '& > *': {
        marginTop: '16px'
      }
    }
  }
});
